var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Login"},[_c('Login',{attrs:{"newForgetPwd":true,"platformName":"视功能检测平台","username":_vm.username,"password":_vm.password},on:{"update:username":function($event){_vm.username=$event},"update:password":function($event){_vm.password=$event},"confirm":_vm.login,"onClickForgetPwd":_vm.onClickForgetPwd}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5443fb8e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/login/Login.vue
// module id = null
// module chunks = 